import React, { FC } from 'react'
import styled from 'styled-components'
import { HeadingL } from 'uiComponents/atoms/Text/Headings'

export const SectionHeaderDefault: FC<{
  title: string
  className?: string
}> = ({ title, className }) => {
  return <HeadingL className={className}>{title}</HeadingL>
}

export const SectionHeaderPadded = styled(SectionHeaderDefault)`
  margin-top: 100px;
  margin-left: 60px;
`
